export function validateStepSetChoice(pickedChoice, stepNode) {
    var noPickedChoice = { pickedChoice: null, nextNode: null };
    if (pickedChoice == null) {
        return noPickedChoice;
    }
    // if the step isn't a decision we don't care about the set_choice value
    var step = stepNode.body;
    if (step == null || step.type !== 'decision') {
        return noPickedChoice;
    }
    // let's iterate over the current step choices to find the right one
    for (var _i = 0, _a = step.choices || []; _i < _a.length; _i++) {
        var choice = _a[_i];
        if (choice.id === pickedChoice) {
            var nextNode = choice.dest;
            // the choice destination is valid?
            if (stepNode.children.indexOf(nextNode) > -1) {
                return { pickedChoice: pickedChoice, nextNode: nextNode };
            }
        }
    }
    return noPickedChoice;
}
